import DodoneFinishButton from 'app/dodones/shared/FinishButton'
import DodoneIgnoreButton from 'app/dodones/shared/IgnoreButton'
import DodoneNextLink from 'app/dodones/shared/NextLink'
import DodoneStartButton from 'app/dodones/shared/StartButton'

const PendingFooter = ({ dodone }) => {
  return (
    <>
      {!dodone.isIgnored && <DodoneIgnoreButton />}
      <DodoneStartButton text="Start" />
      {dodone.isIgnored && <DodoneNextLink currentDodoneId={dodone.id} />}
    </>
  )
}

const StartedFooter = ({ dodone, attributes }) => {
  return (
    <>
      <DodoneFinishButton attributes={attributes} />
    </>
  )
}

const FinishedFooter = ({ dodone }) => {
  return (
    <>
      <DodoneNextLink currentDodoneId={dodone.id} />
    </>
  )
}

export default ({ dodone, attributes }) => {
  if (dodone.isPending || dodone.isIgnored)
    return <PendingFooter dodone={dodone} />

  if (dodone.isFinished)
    return <FinishedFooter dodone={dodone} attributes={attributes} />

  if (dodone.isStarted)
    return <StartedFooter dodone={dodone} attributes={attributes} />

  return <></>
}
